<template>
  <div class="app-container">
    <div class="filter-container">
      <el-row type="flex" justify="end" align="center">
        <el-checkbox v-model="checked" class="flex-ac">全体用户</el-checkbox>
        <el-input
          v-model="listQuery.username"
          placeholder="请输入用户名称"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.last_name"
          placeholder="请输入姓"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.first_name"
          placeholder="请输入名"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.user_id"
          placeholder="请输入用户ID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-input
          v-model="listQuery.uuid"
          placeholder="请输入UUID"
          style="width: 200px"
          class="filter-item"
          clearable
        />
        <el-select
          placeholder="充值类型"
          clearable
          v-model="listQuery.recharge_type"
          style="width: 200px"
          class="filter-item"
        >
          <el-option label="奖励金" value="balance" />
          <el-option label="RP" value="rp" />
          <el-option label="GP" value="hp" />
        </el-select>
        <el-select
          v-model="listQuery.status"
          placeholder="状态"
          clearable
          style="width: 200px"
          class="filter-item"
        >
          <el-option label="处理中" value="pending" />
          <el-option label="已完成" value="completed" />
          <el-option label="撤回处理中" value="revoke_pending" />
          <el-option label="已撤销" value="revoked" />
        </el-select>
        <el-button
          class="filter-item"
          type="primary"
          size="small"
          icon="el-icon-search"
          @click="handleFilter"
          >搜索</el-button
        >
      </el-row>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="用户ID" width="120">
        <template slot-scope="scope">
          {{ scope.row.user_id || '全体用户' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="用户名称" width="120">
        <template slot-scope="scope">
          {{ scope.row.user?.username || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="UUID" min-width="130" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?.uuid || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?.first_name ? scope.row.user.first_name : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="姓" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?.last_name ? scope.row.user.last_name : '-' }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="充值类型" min-width="150">
        <template slot-scope="scope">
          {{ recharge_type(scope.row.recharge_type) }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="充值数量" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.recharge_value }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center" label="可提现" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.user?.can_withdraw ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="已提现" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.user?.withdrawn_balance ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="RP" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.user?.can_use_rp ?? '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="GP" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.user?.can_use_hp ?? '-' }}
        </template>
      </el-table-column> -->

      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'pending'" type="warning">
            处理中
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'recharged'" type="success">
            已充值
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'completed'" type="success">
            已完成
          </el-tag>
          <el-tag
            v-else-if="scope.row.status === 'revoke_pending'"
            type="success"
          >
            撤销处理中
          </el-tag>
          <el-tag v-else-if="scope.row.status === 'revoked'" type="danger">
            已撤销
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="管理员" min-width="150">
        <template slot-scope="scope">
          {{ scope.row.admin.username }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="中文备注" min-width="150">
        <template slot-scope="scope">
          <el-tooltip
            placement="top"
            :disabled="
              !scope.row.remark_list.find((item) => item.lang === 'zh-CN')
                ?.remark ||
              scope.row.remark_list.find((item) => item.lang === 'zh-CN')
                ?.remark.length <= 25
            "
          >
            <div slot="content" style="max-width: 200px">
              {{
                scope.row.remark_list.find((item) => item.lang === 'zh-CN')
                  ?.remark || '-'
              }}
            </div>
            <span class="remark-cell">
              {{
                scope.row.remark_list.find((item) => item.lang === 'zh-CN')
                  ?.remark
                  ? scope.row.remark_list.find((item) => item.lang === 'zh-CN')
                      ?.remark.length > 25
                    ? scope.row.remark_list
                        .find((item) => item.lang === 'zh-CN')
                        ?.remark.substring(0, 25) + '...'
                    : scope.row.remark_list.find(
                        (item) => item.lang === 'zh-CN',
                      )?.remark
                  : '-'
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="英文备注" min-width="150">
        <template slot-scope="scope">
          <el-tooltip
            :content="
              scope.row.remark_list.find((item) => item.lang === 'en_US')
                ?.remark || '-'
            "
            placement="top"
            :disabled="
              !scope.row.remark_list.find((item) => item.lang === 'en_US')
                ?.remark ||
              scope.row.remark_list.find((item) => item.lang === 'en_US')
                ?.remark.length <= 25
            "
          >
            <div slot="content" style="max-width: 200px">
              {{
                scope.row.remark_list.find((item) => item.lang === 'en_US')
                  ?.remark || '-'
              }}
            </div>
            <span class="remark-cell">
              {{
                scope.row.remark_list.find((item) => item.lang === 'en_US')
                  ?.remark
                  ? scope.row.remark_list.find((item) => item.lang === 'en_US')
                      ?.remark.length > 25
                    ? scope.row.remark_list
                        .find((item) => item.lang === 'en_US')
                        ?.remark.substring(0, 25) + '...'
                    : scope.row.remark_list.find(
                        (item) => item.lang === 'en_US',
                      )?.remark
                  : '-'
              }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status !== 'revoked'"
            type="primary"
            size="mini"
            @click="revoke(scope.row)"
          >
            撤销
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="驳回"
      :visible.sync="rejectModalVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="rejectRules"
        label-width="0px"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            placeholder="驳回理由"
            :rows="4"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="rejectModalVisible = false">取消</el-button>
          <el-button type="primary" @click="reject('rejectForm')"
            >确认</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      checked: false,
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        username: '',
        last_name: '',
        first_name: '',
        limit: 10,
        user_id: '',
        recharge_type: '',
        status: '',
      },
    }
  },
  created() {
    this.getList()
  },
  watch: {
    checked(nval, oval) {
      if (nval) {
        this.listQuery.user_id = 0
        this.getList()
      } else {
        this.listQuery.user_id = ''
        this.getList()
      }
    },
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    status() {
      return (val) => {
        switch (val) {
          case 'pending':
            return '处理中'
          case 'recharged':
            return '已充值'
          case 'revoke_pending':
            return '撤回处理中'
          case 'revoked':
            return '已撤回'
          case 'completed':
            return '已完成'
        }
      }
    },
    recharge_type() {
      return (val) => {
        switch (val) {
          case 'balance':
            return '奖励金'
          case 'rp':
            return 'RP'
          case 'hp':
            return 'GP'
          default:
            break
        }
      }
    },
  },
  methods: {
    revoke(row) {
      this.$confirm('是否撤销该条记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/userRecharge/revoke',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/userRecharge/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/USER/edituserinfo')
    },
    createuser() {
      this.$router.push('/USER/createuser')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.flex-ac {
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.remark-cell {
  cursor: default;
  display: inline-block;
  max-width: 100%;
}
</style>
